import axios from "axios";

const url = process.env.REACT_APP_BASE_API_URL;

export const getClienteLocal = async (cliId) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(url + `/v1/cliente/localidade/${cliId}`, { headers });
};

export const insertClienteLocal = async (clienteLocal) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.post(url + "/v1/cliente/localidade/insert", clienteLocal, { headers });
};

export const deleteClienteLocal = async (cliId) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.delete(url + `/v1/cliente/localidade/delete/${cliId}`, { headers });
};

export const updateClienteLocal = async (cliId, body) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.put(url + `/v1/cliente/localidade/update/${cliId}`, body, { headers });
};